import { Box, Divider, Typography } from '@mui/material'
import { Dayjs } from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { US_DATE_TIME_WITH_MONTH_NAME } from '@/api/constants'
import { theme } from '@/theme/theme'
import Rocket from './Rocket'

type CanceledCampaignTimeFrameParams = {
  startDate: Dayjs
  endDate: Dayjs
  updateDate: Dayjs
}

const CanceledCampaignTimeFrame: FC<CanceledCampaignTimeFrameParams> = ({ startDate, endDate, updateDate }) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent={'center'} gap={1} minHeight={242}>
      <Typography textAlign="center"> {t('campaignDashboard.timeFrame.initialSchdule')}</Typography>
      <Typography textAlign="center" textTransform="uppercase" fontWeight={theme.typography.fontWeightSemiBold}>
        {startDate.format(US_DATE_TIME_WITH_MONTH_NAME)} - {endDate.format(US_DATE_TIME_WITH_MONTH_NAME)}
      </Typography>
      <Divider sx={{ width: '100%', margin: theme.spacing(2, 0, 1) }} />
      <Rocket isFly={false} />
      <Typography textAlign="center">{t('campaignDashboard.timeFrame.canceledAt')}</Typography>
      <Typography textAlign="center" textTransform="uppercase" fontWeight={theme.typography.fontWeightSemiBold}>
        {updateDate.format(US_DATE_TIME_WITH_MONTH_NAME)}
      </Typography>
    </Box>
  )
}

export default CanceledCampaignTimeFrame
